﻿import { useTranslation } from "react-i18next";

export default function WanneerSlotenmaker() {
  const { t } = useTranslation("slotenmaker-eindhoven");
  const items = t("wanneer.items", { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  // Safety check: ensure items is an array
  const safeItems = Array.isArray(items) ? items : [];

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-6 md:mb-8">
          {t("wanneer.h2")}
        </h2>
        <p className="font-geist text-base md:text-lg text-brand-text/70 max-w-[900px] mb-10 md:mb-14 leading-relaxed">
          {t("wanneer.intro")}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {safeItems.map((item, i) => (
            <div
              key={i}
              className="bg-brand-cream rounded-2xl p-6 md:p-8 border border-brand-border/60"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-full bg-brand-yellow/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="font-geist font-bold text-sm text-brand-text">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div>
                  <h3 className="font-geist font-bold text-base md:text-lg text-brand-text mb-2">
                    {item.title}
                  </h3>
                  <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                    {item.text}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
